import React, { type PropsWithChildren } from 'react';
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import { SpotlightTransition } from '@atlaskit/onboarding';
import { canMigrateToNewSpotlightPackage } from '../common/canMigrateToNewSpotlightPackage.tsx';

export const ConditionalSpotlightTransition = ({
	children,
}: PropsWithChildren): React.JSX.Element => {
	if (canMigrateToNewSpotlightPackage()) {
		return <>{children}</>;
	}
	return <SpotlightTransition>{children}</SpotlightTransition>;
};
